<template>
  <div :id="self.primerCardElId">
    <!-- TODO: Add content -->
  </div>
</template>

<script setup lang="ts">
import { onMounted, toRef } from 'vue';

import { PaymentStatePackage } from '@/pages/payment/store/payment-state';

import { useSelf } from './hooks/use-self/use-self';

const props = withDefaults(
  defineProps<{
    pkg: PaymentStatePackage;
    isAuthorizeCardToken?: boolean;
  }>(),
  {
    isAuthorizeCardToken: false,
  },
);

const self = useSelf({
  pkg: toRef(props, 'pkg'),
  isAuthorizeCardToken: props.isAuthorizeCardToken,
});

onMounted(() => {
  self.mount();
});
</script>

<style scoped></style>
